<template>
  <section id="dashboard">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard-teacher">Home</a><span>/</span><span>Change Password</span>
        </h4>
      </div>
    </div>
    <div class="card z-dept-5 shadow p-3">
      <form>
        <div class="row">
          <div class="form-group col-md-12">
            <label>Current Password</label>
            <input
              type="password"
              ref="current_password"
              class="form-control mb-2"
              placeholder="Current Password"
            />
          </div>
          <div class="form-group col-md-6">
            <label>New Password</label>
            <input
              type="password"
              ref="new_password"
              class="form-control mb-2"
              placeholder="New Password"
            />
          </div>
          <div class="form-group col-md-6">
            <label>Confirm New New Password</label>
            <input
              type="password"
              ref="confirm_password"
              class="form-control mb-2"
              placeholder="Confirm New Password"
            />
          </div>
        </div>

        <!-- Sign in button -->
        <button class="btn btn-info btn-block my-4" @click.prevent="updatePassword()">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm mr-2"
            role="status"
            aria-hidden="true"
          ></span
          >Update Password
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      totalStudents: "",
      totalTeachers: "",
      totalLevels: "",
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      teacherDetails: [],
      loading: false,
    };
  },
  methods: {
    updatePassword() {
      this.loading = true;
      if (
        this.$refs.current_password.value == "" ||
        this.$refs.new_password.value == "" ||
        this.$refs.confirm_password.value == ""
      ) {
        this.$toast.open({
          message: "ERROR : All Fields Are Required",
          type: "error",
        });
        this.loading = false;
      } else if (this.$refs.new_password.value !== this.$refs.confirm_password.value) {
        this.$toast.open({
          message: "ERROR : New Password and Confirm Password Does Not Match",
          type: "error",
        });
        this.loading = false;
      } else {
        let data = {
          current_password: this.$refs.current_password.value,
          new_password: this.$refs.new_password.value,
        };
        const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Updating Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/account/password/update", data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Password Updated Successfully",
                type: "success",
              });
              this.loading = false;
              window.location = "";
            }
          })
          .catch((error) => {
            if (error.response.data) {
              this.$toast.open({
                message: "Error : " + error.response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Network/Server error please refresh try again",
                type: "error",
              });
            }
            this.loading = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
